import React from 'react';
import logo from '@/assets/images/logo1.png';

const Logo = () => {
  return (
    <div className="flex flex-col items-center justify-center relative py-2">
      {/* Site name with shell icon in between */}
      <div>
                {/* Shell Logo in the middle */}
        <div className="relative group">
          <img 
            src={logo} 
            alt="Vastu Sindhu Logo" 
            className="h-10 w-10 object-contain transition-transform duration-300 group-hover:scale-110 group-hover:rotate-12" 
          />
        </div>
      </div>
      <div className="flex items-center gap-1 mb-1">
        <span className="text-xl font-bold text-gray-800 uppercase tracking-wider">
          VASTU
        </span> 
        <span className="text-xl font-bold text-gray-800 uppercase tracking-wider">
          SINDHU
        </span>
      </div>
      {/* Decorative underline with gradient */}
      <div className="w-full h-0.5 bg-gradient-to-r from-transparent via-customColor to-transparent"></div>
    </div>
  );
};

export default Logo;
